import { Typography, theme } from 'antd';
import { InfoBoxEcho } from '@/components';

const listStyle = (token: ReturnType<typeof theme.useToken>['token']) => ({
  listStylePosition: 'outside' as const,
  paddingInlineStart: token.paddingMD,
  marginBlock: token.marginXS,
});

export const WhenAreCampaignsPaidOutEcho = () => {
  const { token } = theme.useToken();

  return (
    <InfoBoxEcho
      title="When are campaigns paid out?"
      link={{
        to: 'https://learn.acast.com/en/articles/5146617-how-and-when-will-i-get-paid',
        text: 'Learn more about when earnings get paid',
      }}
    >
      <ul role="list" style={{ ...listStyle(token), listStyleType: 'disc' }}>
        <li>
          <Typography.Text>
            <Typography.Text strong>Most campaign types</Typography.Text> are ready for payout in
            the <Typography.Text strong>month after they generate earnings</Typography.Text>,
            although some specific campaigns may have different timelines.
          </Typography.Text>
        </li>
        <li>
          <Typography.Text>
            <Typography.Text strong>Programmatic</Typography.Text> campaigns are ready for payout{' '}
            <Typography.Text strong>after two months</Typography.Text> due to the need for
            additional verification. For example, Programmatic earnings from January might appear on
            your statements in March or April.
          </Typography.Text>
        </li>
      </ul>
    </InfoBoxEcho>
  );
};

export const WhatIsTheDifferenceBetweenCampaignTypesEcho = () => {
  const { token } = theme.useToken();

  return (
    <InfoBoxEcho
      intent="secondary"
      title="What is the difference between campaign types?"
      link={{
        to: 'https://learn.acast.com/en/articles/11419220-campaign-types',
        text: 'Learn more about campaign types',
      }}
    >
      <ul role="list" style={{ ...listStyle(token), listStyleType: 'disc' }}>
        <li>
          <Typography.Text>
            Some categories, such as ads and programmatic, require little to no action from you to
            generate revenue and are controlled by your ad settings and blocklist.
          </Typography.Text>
        </li>
        <li>
          <Typography.Text>
            Others, which may represent a larger revenue source, require your direct approval and
            involvement in producing assets through AdCollab.
          </Typography.Text>
        </li>
      </ul>
    </InfoBoxEcho>
  );
};
